import { LocationCoords } from './location-coords.type';
export interface ParkingPointSaveData {
  location: LocationCoords;
  address: string | null;
}

export class ParkingPoint {
  id!: number;

  location!: LocationCoords;
  likeCount!: number;
  dislikeCount!: number;
  address!: string | null;

  constructor(props: ParkingPoint) {
    if (props) {
      Object.assign(this, props);
    }
  }
}
